export default __webpack_public_path__ + "static/media/wheelchair.6c96e15d.svg";